export const environment = {
  env: 'dev',
  production: false,
  api: 'https://dev-api.travelmedicalseminars.com/api/',
  gAnalyticsId: '',
  gAdsId: '',
  gAdsKey: '',
};
